import React, { useEffect } from 'react';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'core/store';
import ContractForm from 'pages/WirelineEngagements/shared/ContractForm';
import getCustomerAction from 'core/actions/Customers/GetCustomerById/actions';
import { getContractBundlesAction } from '@EngagementsSowData/GetContractBundles';

interface IContractFormViewProps {
  backRoutePath: string
}

const ContractFormView: React.FC<IContractFormViewProps> = ({
  backRoutePath,
}) => {
  const dispatch = useAppDispatch();
  const { contractBundleId, customerId } = useParams();

  const requestedContractData = useAppSelector(
    (state) => state.wirelineEngagements.contractBundles.data);

  const isLoading = useAppSelector(
    (state) => state.wirelineEngagements.contractBundles.isLoading);

  const subAccountId = useAppSelector(
    (state) => state.customers.customer.customerData.subAccountId);

  const uniqueRequestedOrdersByLocation = groupBy(
    requestedContractData.contracts, ({ order }) => order.location);

  const numberOfOrders = requestedContractData.contracts.length;
  const contractDetailsOrders = map(uniqueRequestedOrdersByLocation, (value, key) => ({
    location: [key],
    product: value.map((order) => ({
      name: order.order.product,
      id: order.id,
    })),
  }));

  useEffect(() => {
    dispatch(getContractBundlesAction(String(contractBundleId)));
    dispatch(getCustomerAction(customerId));
  }, []);

  return (
    <ContractForm
      isViewMode
      isLoading={isLoading}
      subAccountId={subAccountId}
      backRoutePath={backRoutePath}
      numberOfOrders={numberOfOrders}
      initialValues={requestedContractData}
      contractDetailsOrders={contractDetailsOrders}
    />
  );
};

export default ContractFormView;
